"use client";

import type { QueryClient } from "@tanstack/react-query";

import { invalidatePublishedLinksQuery } from "@/hooks/queries/usePublishedLinksQuery";
import { patchScrollInAllQueries } from "@/lib/client/scroll-query-cache";
import type { Scroll } from "@/lib/supabase";

let queryClient: QueryClient | null = null;

export function registerScrollQueryClient(qc: QueryClient) {
  queryClient = qc;
}

/** Sync scroll list caches from notebook runtime (title, pin, archive, etc.). */
export function syncScrollFieldsToQueryCache(
  scrollId: string,
  patch: Partial<Scroll>,
) {
  if (!queryClient || !scrollId) return;
  patchScrollInAllQueries(queryClient, scrollId, patch);
  if ("is_published" in patch || "publish_paused" in patch) {
    invalidatePublishedLinksQuery(queryClient);
  }
}
